export class LoginUserRequestModel {
  public Email: string;
  public Password: string;
  public RememberMe: boolean;
  public RecaptchaToken: string;
  public Roles : string[];
  public IsTwoFactorRememberClient: boolean;

  public constructor (email: string, password: string, rememberMe: boolean) {
    this.Email = email;
    this.Password = password;
    this.RememberMe = rememberMe;
  }
}
